import { apiRequest } from '../api';

// The employee change log (batch 10 R2, PAY-6) — the shape server/src/services/employeeWrite.ts
// employeeChangeLog() returns, field for field, and its one admin call (Admin › Audit Log › Employee
// changes, behind requireAuth + requireAdmin).

export type EmployeeChangeRow = {
  id: number; at: number; client_id: string; client_name: string; employee_id: string; employee_name: string;
  action: string; field: string; old_value: any; new_value: any; actor_id: string; actor_name: string; source: string; op_id: string;
};
export type EmployeeChangePage = {
  rows: EmployeeChangeRow[]; total: number; page: number; limit: number;
  clients: { id: string; name: string }[];
};

export const empLogApi = {
  changes: (f: { clientId?: string; page?: number } = {}): Promise<EmployeeChangePage> => {
    const qs = new URLSearchParams();
    if (f.clientId) qs.set('clientId', f.clientId);
    if (f.page && f.page > 1) qs.set('page', String(f.page));
    const q = qs.toString();
    return apiRequest('GET', `/admin/employee-changes${q ? `?${q}` : ''}`);
  },
};
